module.exports = __webpack_public_path__ + "static/img/NZ@3x.8b41c361.jpg";